export default {
  orders: (state) => state.orders,
  totalOrders: (state) => state.totalOrders,
  customerOrders: (state) => state.customerOrders,
  totalCustomerOrders: (state) => state.totalCustomerOrders,
  loading: (state) => state.loading,
};
